import { UserRoles } from './constants/common.constants';

export interface RoleCapabilityConfig {
    role: UserRoles;
    roleid: number;
    showDashboard: boolean;
    storeTableStorageDatainDB: boolean;
}


export const roleCapabilitiesConfig: RoleCapabilityConfig[] = [
    {
        role: UserRoles.ICD10_OD,
        roleid: 1, // OD
        showDashboard: false,
        storeTableStorageDatainDB: false
    },
    {
        role: UserRoles.ICD10_GM,
        roleid: 2, // GM
        showDashboard: false,
        storeTableStorageDatainDB: false
    },
    {
        role: UserRoles.ICD10_CCT,
        roleid: 3, // CCT
        showDashboard: true,
        storeTableStorageDatainDB: true
    }, {
        role: UserRoles.ICD10_CM,
        roleid: 4, // CM
        showDashboard: false,
        storeTableStorageDatainDB: false
    },
    {
        role: UserRoles.ICD10_OTHER,
        roleid: 5, // OTHER
        showDashboard: false,
        storeTableStorageDatainDB: false
    },
    {
        role: UserRoles.ICD10_DM,
        roleid: 6, 
        showDashboard: false,
        storeTableStorageDatainDB: false
    },
    {
        role: UserRoles.ICD10_CEC,
        roleid: 8, 
        showDashboard: false,
        storeTableStorageDatainDB: false
    }

];

